// Returning-visitor 10% discount modal. Modal state only — visit counting lives in
// UserAnalytics, which also gives returning users a +1 head start against the
// threshold below: docs/user-analytics.md#pre-existing-users

export const RETOUCH_STORAGE_KEY = 'ultrahuman_retouch_flow';

/** Compared against UserAnalytics `ringVisits`. */
export const VISITS_THRESHOLD = 4;

export const MODAL_DELAY_MS = 3000;

export const RETOUCH_AFFILIATE_CODE = 'retouch';

export const BUY_PAGE_PATTERN = '/ring/buy';

export const MODAL_CONTENT = {
  title: 'Still thinking it over?',
  subtitle: "Here's 10% off to help you decide",
  ctaText: 'Claim My Discount',
  closeAriaLabel: 'Close discount modal',
};

// Event names below are read by GTM/Vercel Analytics — external identifiers, don't rename.

export const ANALYTICS_EVENTS = {
  ELIGIBLE: 'retouch_flow_eligible',
  MODAL_SHOWN: 'retouch_flow_modal_shown',
  MODAL_CLOSED: 'retouch_flow_modal_closed',
  CTA_CLICKED: 'retouch_flow_cta_clicked',
  DISCOUNT_CLAIMED: 'retouch_flow_discount_claimed',
  SUPPRESSED_BY_CAMPAIGN: 'retouch_flow_suppressed_by_campaign',
  SUPPRESSED_BY_AFFILIATE: 'retouch_flow_suppressed_by_affiliate',
};

export const GTM_EVENTS = {
  ELIGIBLE: 'retouchFlowEligible',
  MODAL_SHOWN: 'retouchFlowModalShown',
  MODAL_CLOSED: 'retouchFlowModalClosed',
  CTA_CLICKED: 'retouchFlowCtaClicked',
  DISCOUNT_CLAIMED: 'retouchFlowDiscountClaimed',
  SUPPRESSED_BY_CAMPAIGN: 'retouchFlowSuppressedByCampaign',
  SUPPRESSED_BY_AFFILIATE: 'retouchFlowSuppressedByAffiliate',
};

export interface RetouchFlowData {
  modalShown: boolean;
  discountClaimed: boolean;
}

export const DEFAULT_RETOUCH_DATA: RetouchFlowData = {
  modalShown: false,
  discountClaimed: false,
};
